<template>
  <div>
    <h3
      v-if="summary.package.name"
      class="text-primary text-uppercase d-flex justify-content-between"
    >
      <span>{{ summary.package.name }}</span>
      <span>${{ summary.package.annualFee }}</span>
    </h3>
    <ul class="summary-list">
      <li
        class="item"
        v-for="(item, i) in (domains && domains.length > 0 ? domains : summary.domain)"
        :key="`domain-${i}`"
      >
        <span v-if="i === 0" class="text-secondary">{{ $t(`global.${domainTitle}`) }}</span>
        <span v-else></span>
        <span>{{ item }}</span>
      </li>
    </ul>
    <div class="d-flex justify-content-between my-1">
      <h3>{{ $t("global.total") }}</h3>
      <h3>{{ `$${summary.package.annualFee || "0.00"}` }}</h3>
    </div>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api";

export default {
  name: "CertificateAddSummary",
  props: {
    domains: Array,
    summary: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const domainTitle = computed(() => "domain");
    return {
      domainTitle,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";

.summary-list {
  list-style: none;
  padding-left: 0px;

  li {
    border-bottom: 1px solid #efefef;
    margin-bottom: 5px;
  }

  .item {
    display: flex;
    justify-content: space-between;
  }
}
</style>
